<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-img aspect-ratio="16/9" cover src="https://i.ibb.co/6Rb7VmJW/logo.png" class="mb-3 rounded-lg"></v-img>

        <v-card>
          <v-card-text>
            <v-text-field v-model="ip" :rules="[() => !!ip || 'This field is required']" label="Indirizzo di rete"
              placeholder="192.168.1.0" required></v-text-field>

            <v-text-field v-model="sm" :rules="[() => !!sm || 'This field is required']" label="Subnet Mask"
              placeholder="255.255.255.0" required></v-text-field>

            <v-row>
              <v-col cols="8">
                <v-text-field v-model="nrsottoreti" type="number"
                  :rules="[() => !!nrsottoreti || 'This field is required']" label="Numero di sottoreti" placeholder="2"
                  required></v-text-field>
              </v-col>

              <v-col cols="4">
                <v-btn elevation="12" size="x-large" color="primary" @click="genera">
                  Genera
                </v-btn>
              </v-col>
            </v-row>

            <!-- Campi sottoreti -->
            <v-row v-for="index in righe" :key="index">
              <v-col cols="8">
                <v-text-field v-model="nomiSottoreti[index - 1]" :label="`Nome sottorete ${index}`"
                  required></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model.number="hostPerSottorete[index - 1]" type="number" label="Nr hosts"
                  placeholder="2" required></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider class="mt-6"></v-divider>

          <v-card-actions>
            <v-row>
              <v-col cols="6" class="text-center">
                <v-btn variant="text" @click="resetForm">Reset</v-btn>
              </v-col>
              <v-col cols="6" class="text-center">
                <v-btn color="primary" variant="text" @click="calcola">Calcola</v-btn>
              </v-col>
            </v-row>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- Sezione risultati -->
    <v-row justify="center" v-if="results.length > 0">
      <v-col cols="12" lg="10" md="8" sm="10">
        <v-card class="mx-auto" prepend-icon="mdi-information" :subtitle="'Subnet Mask: ' + sm">
          <template v-slot:title>
            <span class="font-weight-black">Indirizzo IP: {{ ip }}</span>
          </template>

          <v-card-text class="bg-surface-light pt-2">
            <v-data-table :items="results" :items-per-page="-1" hide-default-footer striped="even"></v-data-table>

            <v-btn color="secondary" class="mt-4" @click="stampaRisultati">
              Stampa risultati
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- Snackbar -->
    <v-snackbar :timeout="2000" class="elevation-24" color="blue-grey-darken-1" v-model="snackbar">
      Ip e Subnet Mask non validi!
    </v-snackbar>
    <v-snackbar :timeout="2000" class="elevation-24" color="blue-grey" v-model="snackbar2">
      Ip non valido!
    </v-snackbar>
    <v-snackbar :timeout="2000" class="elevation-24" color="blue-grey" v-model="snackbar3">
      Subnet Mask non valida!
    </v-snackbar>
  </v-container>

</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Elaborazioni",
  data() {
    return {
      ip: "",
      sm: "",
      nrsottoreti: "",
      righe: 0,
      sottoreti: [],
      nomiSottoreti: [],
      hostPerSottorete: [],
      results: [],
      snackbar: false,
      snackbar2: false,
      snackbar3: false,
    };
  },
  methods: {
    genera() {
      this.righe = parseInt(this.nrsottoreti) || 0;
      this.nomiSottoreti = [];
      this.hostPerSottorete = [];

      for (let i = 1; i <= this.righe; i++) {
        this.nomiSottoreti.push(`Rete${i}`);
        this.hostPerSottorete.push(0);
      }
    },

    resetForm() {
      this.ip = "";
      this.sm = "";
      this.nrsottoreti = "";
      this.righe = 0;
      this.nomiSottoreti = [];
      this.hostPerSottorete = [];
      this.sottoreti = [];
      this.results = [];
    },

    calcola() {
      if (!this.isValidIp(this.ip) && !this.isValidMask(this.sm)) {
        this.snackbar = true;
        return;
      }
      if (!this.isValidIp(this.ip)) {
        this.snackbar2 = true;
        return;
      }
      if (!this.isValidMask(this.sm)) {
        this.snackbar3 = true;
        return;
      }

      this.sottoreti = this.nomiSottoreti.map((nome, i) => ({
        nomeSottorete: nome,
        nrHost: this.hostPerSottorete[i],
      }));

      this.calculateVLSM(this.ip, this.sm, this.sottoreti);
    },

    isValidIp(ip) {
      const parts = ip.split(".");
      if (parts.length !== 4) return false;
      return parts.every((part) => {
        const num = parseInt(part);
        return !isNaN(num) && num >= 0 && num <= 255;
      });
    },

    isValidMask(mask) {
      if (!this.isValidIp(mask)) return false;
      const maskNum = this.maskToNumber(mask);
      let foundZero = false;
      for (let i = 31; i >= 0; i--) {
        const bit = (maskNum >>> i) & 1;
        if (foundZero && bit === 1) return false;
        if (bit === 0) foundZero = true;
      }
      return true;
    },

    maskToNumber(mask) {
      return this.ipToNumber(mask);
    },

    ipToNumber(ip) {
      const parts = ip.split(".");
      return (
        (parseInt(parts[0]) << 24) +
        (parseInt(parts[1]) << 16) +
        (parseInt(parts[2]) << 8) +
        parseInt(parts[3])
      );
    },

    numberToIp(num) {
      return [
        (num >>> 24) & 0xff,
        (num >>> 16) & 0xff,
        (num >>> 8) & 0xff,
        num & 0xff,
      ].join(".");
    },

    cidrToMask(cidr) {
      const maskNum = (0xffffffff << (32 - cidr)) >>> 0;
      return this.numberToIp(maskNum);
    },

    maskToCidr(mask) {
      const maskNum = this.maskToNumber(mask);
      let cidr = 0;
      let bit = 0x80000000;
      while ((maskNum & bit) !== 0) {
        cidr++;
        bit >>>= 1;
      }
      return cidr;
    },

    getHostCountForCidr(cidr) {
      return Math.pow(2, 32 - cidr) - 2;
    },

    getCidrForHostCount(hostCount) {
      const needed = hostCount + 2;
      for (let cidr = 32; cidr >= 0; cidr--) {
        if (Math.pow(2, 32 - cidr) >= needed) return cidr;
      }
      return 0;
    },

    calculateVLSM(networkAddress, subnetMask, subnets) {
      const networkNum = this.ipToNumber(networkAddress);
      const baseCidr = this.maskToCidr(subnetMask);

      const sortedSubnets = [...subnets].sort((a, b) => b.nrHost - a.nrHost);
      const totalHostsNeeded = sortedSubnets.reduce((sum, s) => sum + s.nrHost, 0);
      const availableHosts = this.getHostCountForCidr(baseCidr);

      if (totalHostsNeeded > availableHosts) {
        throw new Error(
          `Numero di host insufficiente. Disponibili: ${availableHosts}, Richiesti: ${totalHostsNeeded}`
        );
      }

      this.results = [];
      let currentNetworkNum = networkNum;

      for (const subnet of sortedSubnets) {
        const requiredCidr = this.getCidrForHostCount(subnet.nrHost);
        const subnetSize = Math.pow(2, 32 - requiredCidr);
        const broadcastNum = currentNetworkNum + subnetSize - 1;
        const firstHostNum = currentNetworkNum + 1;
        const lastHostNum = broadcastNum - 1;
        const gatewayNum = broadcastNum - 1;

        this.results.push({
          Nome: subnet.nomeSottorete,
          "Nr Host": subnet.nrHost,
          "Network": this.numberToIp(currentNetworkNum),
          "First Host": this.numberToIp(firstHostNum),
          "Last Host": this.numberToIp(lastHostNum),
          "Gateway": this.numberToIp(gatewayNum),
          "Broadcast": this.numberToIp(broadcastNum),
          "Subnet Mask": this.cidrToMask(requiredCidr),
          "CIDR": `/${requiredCidr}`,
        });

        currentNetworkNum += subnetSize;
      }
    },

    stampaRisultati() {
      const tableContent = document.querySelector(".v-data-table").outerHTML;
      const titolo = `Risultati VLSM - ${this.ip}/${this.maskToCidr(this.sm)}`;

      const printWindow = window.open("", "", "width=900,height=700");
      printWindow.document.write(`
        <html>
          <head>
            <title>${titolo}</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #444; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
              body { font-family: Arial, sans-serif; margin: 20px; }
            </style>
          </head>
          <body>
            <h2>${titolo}</h2>
            ${tableContent}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    },
  },
};
</script>
